import React from 'react';
import { connect } from 'react-redux';

const WrappedComp = ({ Component, pageStatus, ...props }) => (
  <Component {...props} pageComplete={pageStatus && pageStatus.stepIsComplete} />
);

const takePage = (page) => connect(state => ({
  pageStatus: state.register[page],
}))(WrappedComp);


export default (page) => {
  const WrappedComponent = takePage(page);
  return (Component) => (props) => (
    <WrappedComponent Component={Component} {...props} />
  )
};
